import { createSelector } from '@reduxjs/toolkit';
import { get } from 'lodash/fp';
import type { RootState } from 'app/store/reducers';
import { toStringFqn } from 'app/lib/utils';

type Props = {
    entityId: string;
    queryUuid: string;
    fqn: string;
};
const selectSlice = (state: RootState) => state.columnFilter;
const selectPropEntityId = (_: RootState, props: Props) => props.entityId;
const selectPropFqn = (_: RootState, props: Props) => props.fqn;
const selectPropQueryUuid = (_: RootState, props: Props) => props.queryUuid;

const selectDatasetColumnFilter = createSelector(selectSlice, get(['byLocation', 'dataset']));

const selectExploreColumnFilter = createSelector(selectSlice, get(['byLocation', 'explore']));

export const selectDatasetColumnFilterForEntityId = createSelector(
    [selectDatasetColumnFilter, selectPropEntityId],
    (columnFilter, entityId) => columnFilter?.[entityId]
);

export const selectDatasetColumnFilterForPropFqn = createSelector(
    [selectDatasetColumnFilter, selectPropFqn],
    (columnFilter, fqn) => columnFilter?.[toStringFqn(fqn)]
);

export const selectExploreColumnFilterForQueryUuid = createSelector(
    [selectExploreColumnFilter, selectPropEntityId, selectPropQueryUuid],
    (columnFilter, entityId, queryUuid) => columnFilter?.[entityId]?.[queryUuid]
);
